module.exports = __webpack_public_path__ + "src/assets/img/sampleDISC.a61e4d95.png";